import { StatusDaEtapa } from './enum';

export class Etapa {
  id: number;
  descricao: string;
  textoAcompanhamento: string;
  ordem: number;
  fixa: boolean;
  ativa: boolean;
  enviarEmail: boolean;
  idTemplateEmail: number;
  status: StatusDaEtapa;
  somenteApi: boolean;
  visualizaIntegrador: boolean;
}
